import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Stack } from '@mui/material';

import { Modal } from 'components/Modal';
import { FormProvider, TextField } from 'components/Form';
import useYupValidationResolver from 'hook/useYupValidationResolver';

import { useCreateLot } from '../api/createLot';
import { useUpdateLot } from '../api/updateLot';
import { lotValidationSchema } from '../validation';

export const LotFormModal = ({ resource, id, lot, open, handleClose, onSaved }) => {
  const isEdit = !!lot?.lot_id;

  const methods = useForm({
    defaultValues: { name: '', description: '' },
    resolver: useYupValidationResolver(lotValidationSchema),
  });

  const onSuccess = () => {
    onSaved();
    handleClose();
  };
  const { mutateAsync: createLot } = useCreateLot(resource, id, onSuccess);
  const { mutateAsync: updateLot } = useUpdateLot(resource, id, onSuccess);

  const { reset } = methods;
  useEffect(() => {
    if (open) {
      reset({ name: lot?.name ?? '', description: lot?.description ?? '' });
    }
  }, [open, lot, reset]);

  const onSubmit = (values) => {
    const request = isEdit ? updateLot({ lotId: lot.lot_id, ...values }) : createLot(values);
    request.catch(() => {});
  };

  return (
    <Modal title={isEdit ? 'Edit lot' : 'Add lot'} open={open} handleClose={handleClose}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack gap={3} mb={3}>
          <TextField fullWidth name="name" label="Name" placeholder="Please enter name" required />
          <TextField
            fullWidth
            name="description"
            label="Description"
            placeholder="Please enter description"
            multiline
            minRows={3}
            sx={{ '& .MuiInputBase-root': { p: 0 } }}
          />
        </Stack>

        <Stack direction="row" gap={3} justifyContent="center">
          <Button variant="outlined" color="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" type="submit">
            {isEdit ? 'Update' : 'Add'}
          </Button>
        </Stack>
      </FormProvider>
    </Modal>
  );
};
